import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, inputTextColumn, actionDelColumn, imageColumnClick, inputColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P105List_2({ dataTable, setDeleteDialog, setheadlerInpusText, dialogUploadPic, viewImage, displayMode }) {
    const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyDel = (rowData) => setDeleteDialog({ open: true, data: rowData });
    const actionBodyAddPic = () => dialogUploadPic({ dialog: true, show: true });
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive"
                icon="pi pi-image"
                label="เพิ่มรูปถ่าย"
                onClick={() => {
                    actionBodyAddPic();
                }}
                disabled={displayMode()}
            />
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    header={header}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ยังไม่ได้เพิ่มรายการ"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="seqPk" header="รูปที่" body={(e) => normalColumn(e, "seqPk", "รูปที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="photoDesc" header="รายละเอียดรูป" body={(e) => inputColumn(e, "photoDesc", dataTable, setheadlerInpusText, "รายละเอียดรูป", displayMode())} style={{ textAlign: "center", width: "30%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="criteriaDesc" header="รูปถ่าย" body={(e) => imageColumnClick(e, "photoPath", "รูปถ่าย", viewImage)} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="ลบรายการ" field="photoPath" body={(e) => actionDelColumn(e, actionBodyDel, displayMode())} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
